import { createContext } from "react";

/**
 * How the integration cards draw: logo tiles (the connected list, onboarding) or full-width rows
 * with what each integration does (the Add Integration dialog). A context, so the dozen cards
 * keep their own connect flows and only BasicIntegrationCard changes.
 */
export const IntegrationCardLayoutContext = createContext<"tile" | "row">("tile");

/** Set on the connected list: a linked card offers "View details" through it. */
export const IntegrationDetailsContext = createContext<((integrationId: string) => void) | undefined>(undefined);
